import React from "react";

interface IProps {
  width?: string | number
  height?: string | number
}

const SendIcon = ({ width, height }: IProps) => (
  <svg width={width} height={height} viewBox="0 0 576 512">
    <path
      d="M81.9 27.8C47.1 12.7 12.8 50.1 30.8 83.5l69.3 128.8c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L30.8 428.5c-18 33.4 16.3 70.8 51.1 55.7L523.8 292.7c32.1-13.9 32.1-59.5 0-73.4L81.9 27.8z"
      fill="#0082de"
    />
  </svg>
);

export default SendIcon;
